import React from 'react';
import { SadEmotion, VerySadEmotion, NeutralEmotion, HappyEmotion, VeryHappyEmotion } from '../../assets/vectors';

interface EmotionProps {
  index: number;
  size?: number;
}

const Emotion: React.FC<EmotionProps> = ({ index, size = 20 }) => {
  const svgProps = {
    width: undefined,
    height: undefined,
    viewBox: '0 0 20 20',
    style: {
      width: size,
      height: size,
    },
  };

  switch (index) {
    case 0:
      return <VerySadEmotion {...svgProps} />;
    case 1:
      return <SadEmotion {...svgProps} />;
    case 2:
      return <NeutralEmotion {...svgProps} />;
    case 3:
      return <HappyEmotion {...svgProps} />;
    case 4:
      return <VeryHappyEmotion {...svgProps} />;
    default:
      return null;
  }
};

export default Emotion;
